import React from "react";
import banner1 from "../assets/banner1.jpg"; // replace with actual image path

export default function ManagementConsulting() {
  return (
    <section className="py-5">
      
      {/* Heading */}
      <div className="text-center mb-3">
        <h2 className="main-section-title fw-bold">Management Consulting</h2>
        <p className="text-muted small">
          Expert guidance to improve organisational performance and strategy.
        </p>
      </div>

      {/* Image */}
      <div className="mb-4">
        <img 
          src={banner1} 
          alt="Management Consulting" 
          className="img-fluid rounded w-100"
        />
      </div>

      {/* Elaborative Text */}
      <div className="container">
        <p className="text-muted fs-6">
          Zamani Sabios Group offers comprehensive management consulting services aimed at 
          enhancing organisational effectiveness, strategy, and operational efficiency. 
		  <br/><br/>
          Our team provides practical, evidence-based solutions tailored to client needs, 
          covering organisational strategy, operational reviews, performance improvement, 
          and institutional strengthening. We leverage decades of combined experience 
          to deliver actionable insights and sustainable growth for public, private, 
          and nonprofit organisations.
        </p>
      </div>

    </section>
  );
}
